var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 778,
    viewBox: "0 0 1440 778",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1438 727C1220 793.849 1118 721 1024.85 673.109C886.327 601.888 826 575.797 626.001 673.109C426.002 770.421 210.926 822.954 38.0001 727C-87.9602 657.107 -74.9791 431.001 -74.9791 431.001C-102.918 343.987 -60.999 209 159.001 187C382.004 164.7 460.777 287.001 655.021 287.001C888.049 287.001 1008.46 167.539 1219.02 66.9998C1441.02 -39.0002 1647 13.0005 1647 13.0005L1647 535C1647 535 1656.4 660.029 1438 727Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1614.19 244.602) rotate(178.905) scale(1660.97 686.306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.222547,
    stopColor: "#4D2372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581608,
    stopColor: "#5673ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BEF8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain5);
export default __webpack_public_path__ + "static/media/mountain5.5d9d098c21f2a3875640c981aa76670e.svg";
export { ForwardRef as ReactComponent };